import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { LearnMore } from './learn-more';

/** Explains the next step instead of showing a blank screen (PLAN §12.3). */
export function EmptyState({
  icon: Icon,
  title,
  children,
  action,
  learnMore,
}: {
  icon: LucideIcon;
  title: string;
  children?: ReactNode;
  action?: ReactNode;
  learnMore?: string;
}) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed bg-surface px-6 py-12 text-center">
      <Icon className="size-8 text-muted-foreground" aria-hidden="true" />
      <h2 className="text-base font-semibold">{title}</h2>
      {children && <div className="max-w-md text-sm text-muted-foreground">{children}</div>}
      {action}
      {learnMore && <LearnMore slug={learnMore} />}
    </div>
  );
}
